import { render, staticRenderFns } from "./rightCompanyInfo.vue?vue&type=template&id=0b994368&scoped=true&"
import script from "./rightCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./rightCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./rightCompanyInfo.vue?vue&type=style&index=0&id=0b994368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b994368",
  null
  
)

export default component.exports